<mat-list role="list" *ngIf="getPlan()" [class.dense]="dense">
    <ng-container *ngIf="getPlan().show_permissions">
        <mat-list-item role="listitem" *ngFor="let permission of getPlan().permissions | keyvalue">
            <mat-icon class="check-icon" svgIcon="check" *ngIf="showCheckIcons" matListIcon></mat-icon>
            <div class="mat-list-text">{{permission.key}}</div>
        </mat-list-item>
    </ng-container>
    <ng-container *ngIf="getPlan().features.length">
        <mat-list-item role="listitem" *ngFor="let feature of getPlan().features">
            <mat-icon class="check-icon" svgIcon="check" *ngIf="showCheckIcons" matListIcon></mat-icon>
            <div class="mat-list-text">{{feature}}</div>
        </mat-list-item>
    </ng-container>
</mat-list>